// extracted by mini-css-extract-plugin
export default {"fullWidth":"Fm-z","image":"Gm-z","lazyLoadPicture":"Hm-z","lazyLoadSpinner":"Im-z","lazyLoadSpin":"Jm-z","lazyLoadImage":"Km-z","hasStyledAspectRatio":"Lm-z"};